package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Instant

/**
 * Un combat actif sur une table de jeu.
 *
 * Le combat est diffusé en temps réel : le MJ le crée, fait avancer le tour actif
 * ([activeIndex]) et l'arrête. Les joueurs participants reçoivent l'état via Supabase Realtime.
 */
@Serializable
data class ActiveCombat(
    @SerialName("id")
    val id: String,

    @SerialName("table_id")
    val tableId: String,

    @SerialName("created_by")
    val createdBy: String,

    /** Participants ordonnés (personnages joueurs + adversaires). */
    @SerialName("participants")
    val participants: List<CombatParticipant>,

    /**
     * userId des joueurs participants — utilisé pour le RLS et le ciblage Realtime.
     * (Les adversaires n'ont pas de userId et ne sont donc pas inclus.)
     */
    @SerialName("target_participants")
    val targetParticipants: List<String>,

    /** Index du participant dont c'est le tour. */
    @SerialName("active_index")
    val activeIndex: Int,

    @SerialName("is_active")
    val isActive: Boolean,

    @SerialName("created_at")
    val createdAt: Instant
) {
    /** Le participant dont c'est actuellement le tour, ou null si la liste est vide. */
    val activeParticipant: CombatParticipant?
        get() = participants.getOrNull(activeIndex)
}
